import React, { useContext } from 'react';
import { IconButton } from '@one-thd/sui-atomic-components';
import { TrashCan } from '@one-thd/sui-icons';
import { string, bool } from 'prop-types';
import { ProductListContext } from '../ProductListContext';

export const DeleteButton = ({ itemId, iconSize }) => {
  const { removeListItems, isRemoving } = useContext(ProductListContext);

  return (
    <IconButton
      icon={TrashCan}
      iconSize={iconSize}
      aria-label="Delete Item"
      disabled={isRemoving}
      onClick={() => {
        if (!isRemoving) {
          removeListItems([itemId]);
        }
      }}
    />
  );
};

DeleteButton.propTypes = {
  itemId: string.isRequired,
  iconSize: string
};

DeleteButton.defaultProps = {
  iconSize: 'small'
};
